export default __webpack_public_path__ + "static/media/item2.104db5b2.svg";